import { render, staticRenderFns } from "./TransferCheckinTemplate.vue?vue&type=template&id=55c79e6d"
import script from "./TransferCheckinTemplate.vue?vue&type=script&lang=js"
export * from "./TransferCheckinTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports